import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Factory } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToBenefits = () => {
    document.getElementById('benefits')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative flex items-center pt-20 pb-6 lg:pb-4 bg-gradient-to-br from-gray-50 via-blue-50/30 to-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231e40af' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <div className="space-y-6 sm:space-y-8">

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Potenciá tu industria con la{' '}
              <span className="text-blue-600 relative inline-block">
                UIQ
                <svg className="absolute -bottom-2 left-0 w-full" height="12" viewBox="0 0 200 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 10C45.5 3 154.5 3 198 10" stroke="#2563eb" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
              Sumá tu empresa a la Unión Industrial Quilmes. Accedé a asesoramiento técnico, capacitaciones y oportunidades de crecimiento para tu negocio.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:shadow-xl hover:scale-105 group"
              >
                Asociate ahora
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={scrollToBenefits}
                size="lg"
                variant="outline"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-semibold px-8 py-6 text-lg transition-all duration-300"
              >
                Conocé los beneficios
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 sm:gap-8 pt-6 sm:pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl sm:text-4xl font-bold text-blue-600">+180</div>
                <div className="text-sm text-gray-600 mt-1">Empresas socias</div>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl font-bold text-blue-600">+50</div>
                <div className="text-sm text-gray-600 mt-1">Años de trayectoria</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl lg:hover:scale-105 transition-transform duration-500">
              <img
                src="/img/hero-zoom.webp"
                alt="Presentación de plataforma UIQ con autoridades educativas y empresariales"
                className="w-full h-56 sm:h-72 lg:h-auto object-cover"
                loading="eager"
                fetchPriority="high"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent" />
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs hidden lg:block">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Factory className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Red Industrial</p>
                  <p className="text-sm text-gray-600 mt-1">Conectamos empresas para generar oportunidades</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
